import { animate, animateChild, group, query, style, transition, trigger } from '@angular/animations';

// Keep in sync with --mat-tab-animation-duration in _tabs.scss
export const animationDuration = 500;

export function GetAnimationDuration(isMobileOrTablet: boolean): number {
    return isMobileOrTablet ? animationDuration / 2 : animationDuration;
}

export const routeAnimations =
    trigger('routeAnimation', [
        transition('* => fadeInOnly', fadeInOnly()),
        transition('fadeInOnly => *', fadeInOnly()),
        transition('initial => Parent', slideTo('left')),
        transition('initial => Child', slideTo('right')),
        transition('* => Parent', slideTo('left')),
        transition('* => Child', slideTo('right')),
        transition('initial => *', []),
        transition('* => *', crossfade())
    ]);

function slideTo(direction: 'left' | 'right') {
    const optional = { optional: true };
    const enterOffset = direction === 'left' ? '-{{slideOffset}}%' : '{{slideOffset}}%';
    const leaveOffset = direction === 'left' ? '{{slideOffset}}%' : '-{{slideOffset}}%';
    const easing = 'cubic-bezier(0.22, 1, 0.36, 1)';

    return [
        query(':enter, :leave', [
            style({
                position: 'absolute',
                top: 0,
                left: 0,
                opacity: 1,
                width: '100%',
                height: '100%',
                willChange: 'transform'
            })
        ], optional),
        query(':enter', [
            style({ transform: `translate3d(${enterOffset}, 0, 0)`, opacity: 0 })
        ], optional),
        group([
            query(':leave', [
                animate(`{{duration}}ms ${easing}`, style({ transform: `translate3d(${leaveOffset}, 0, 0)`, opacity: 0 }))
            ], optional),
            query(':enter', [
                animate(`{{duration}}ms ${easing}`, style({ transform: 'translate3d(0, 0, 0)', opacity: 1 }))
            ], optional)
        ]),

        query(':leave', animateChild(), optional),
        query(':enter', animateChild(), optional)
    ];
}

function crossfade() {
    const optional = { optional: true };

    return [
        query(':enter, :leave', [
            style({
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                willChange: 'opacity'
            })
        ], optional),
        query(':enter', style({ opacity: 0 }), optional),
        query(':leave', animate('{{duration}}ms ease-in-out', style({ opacity: 0 })), optional),
        query(':enter', animate('{{duration}}ms ease-in-out', style({ opacity: 1 })), optional),
        query(':leave', animateChild(), optional),
        query(':enter', animateChild(), optional)
    ];
}

function fadeInOnly() {
    const optional = { optional: true };

    return [
        query(':enter', [
            style({ opacity: 0 }),
            animate('{{duration}}ms ease-out', style({ opacity: 1 }))
        ], optional)
    ];
}
